import { Box } from '@mui/material'

type BarProps = { color: string }

export default function Bar({ color }: BarProps) {
  return (
    <Box
      sx={{
        width: 4,
        background: color,
      }}
    />
  )
}
